import PageHero from '../components/PageHero'
import PageCardImage from '../components/PageCardImage'
import { SERVICES_CONTENT } from '../content/servicesContent'

export default function ServicesPage() {
  return (
    <div className="page">
      <PageHero
        title={SERVICES_CONTENT.title}
        lead={SERVICES_CONTENT.intro}
        image={SERVICES_CONTENT.heroImage}
        imageAlt="Aegis service areas across the supply chain"
        imagePosition="center 80%"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="page-grid page-grid--3">
            {SERVICES_CONTENT.columns.map((column) => (
              <article key={column.title} className="page-card page-card--media">
                <PageCardImage src={column.image} alt={column.title} />
                <h2 className="page-card__title">{column.title}</h2>
                <p className="page-card__text">{column.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
